import React, { useState } from "react";
import { ShieldCheck, FlaskConical, ClipboardCheck, Building2, Lock, TrendingUp } from "lucide-react";
import FAQAccordionItem from "./FAQAccordionItem";

const ICONS = { ShieldCheck, FlaskConical, ClipboardCheck, Building2, Lock, TrendingUp };

export default function FAQCategorySection({ category }) {
  const [openIndex, setOpenIndex] = useState(null);
  const Icon = ICONS[category.icon] || ShieldCheck;

  return (
    <section id={category.id} className="scroll-mt-28" aria-labelledby={`${category.id}-heading`}>
      <div className="flex items-start gap-4 mb-6">
        <div className="w-11 h-11 rounded-[10px] bg-brand-navy flex items-center justify-center shrink-0">
          <Icon className="w-5 h-5 text-brand-teallight" />
        </div>
        <div>
          <h2 id={`${category.id}-heading`} className="text-2xl font-extrabold text-brand-navy tracking-tight">
            {category.title}
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">{category.tagline}</p>
        </div>
      </div>
      <div className="space-y-3">
        {category.faqs.map((faq, idx) => (
          <FAQAccordionItem
            key={idx}
            faq={faq}
            isOpen={openIndex === idx}
            onToggle={() => setOpenIndex(openIndex === idx ? null : idx)}
          />
        ))}
      </div>
    </section>
  );
}